import React, { useEffect, useState } from "react";
import { AlertCircle, Loader2, Trash2 } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

/** Confirm a permanent user delete: the button unlocks once DELETE is typed. */
export default function DeleteUserDialog({ open, onOpenChange, name, roleLabel = "user", loading, onConfirm }) {
  const [typed, setTyped] = useState("");
  const expected = "DELETE";
  useEffect(() => {
    if (open) setTyped("");
  }, [open]);
  const matches = typed.trim() === expected;

  return (
    <Dialog open={open} onOpenChange={loading ? undefined : onOpenChange}>
      <DialogContent className="sm:max-w-[460px]">
        <DialogHeader>
          <DialogTitle className="flex items-center text-red-600">
            <AlertCircle className="h-5 w-5 mr-2" />
            Delete {roleLabel} permanently
          </DialogTitle>
          <DialogDescription asChild>
            <div className="space-y-3 pt-3 text-sm text-slate-600">
              <p>
                This permanently deletes <strong>{name || `this ${roleLabel}`}</strong>:
              </p>
              <ul className="list-disc space-y-1 pl-5">
                <li>their sign-in account and profile</li>
                <li>every consultation they are part of, for both sides</li>
                <li>pending bookings, withdrawals and chat messages</li>
              </ul>
              <p className="font-semibold text-red-600">This cannot be undone.</p>
            </div>
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <label className="text-sm text-slate-700" htmlFor="delete-user-confirm">
            Type <strong>{expected}</strong> to confirm
          </label>
          <Input
            id="delete-user-confirm"
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
            autoComplete="off"
            disabled={loading}
          />
        </div>
        <DialogFooter className="mt-4 flex justify-end gap-3 sm:justify-end">
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={loading || !matches}
            className="bg-red-600 hover:bg-red-700"
          >
            {loading ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Deleting...
              </>
            ) : (
              <>
                <Trash2 className="h-4 w-4 mr-2" />
                Delete permanently
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
